const API_BASE = process.env.REACT_APP_API_BASE;

if (!API_BASE) {
  throw new Error("REACT_APP_API_BASE is not defined");
}

export const API_URL = API_BASE + "/api";
export const FS_API_URL = API_BASE + "/api";
export const DOWNLOAD_BASE_URL = API_BASE;

export const DEMO_TOKEN = "demo-token";
export const DEMO_CLIENT_ID = "demo-client";
